import { render, staticRenderFns } from "./OrderFinance.vue?vue&type=template&id=350c0467&scoped=true"
import script from "./OrderFinance.vue?vue&type=script&lang=ts"
export * from "./OrderFinance.vue?vue&type=script&lang=ts"
import style0 from "./OrderFinance.vue?vue&type=style&index=0&id=350c0467&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350c0467",
  null
  
)

export default component.exports